import { render, staticRenderFns } from "./TableCancelForm.vue?vue&type=template&id=5920a8bb&"
import script from "./TableCancelForm.vue?vue&type=script&lang=js&"
export * from "./TableCancelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports